/* istanbul ignore file */
import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyles = () => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            helper: css({
                color: theme.palette.foreground.default,
                alignItems: 'flex-start',
                display: 'flex',
                marginTop: theme.orbitalTwo,
                minWidth: 130,
            }),
            helperIcon: css({
                alignItems: 'center',
                display: 'inline-flex',
                height: theme.orbitalSix,
                justifyContent: 'center',
                marginRight: theme.orbitalOne,
                maxWidth: theme.orbitalSix,
                width: '100%',
            }),
            helperText: css({
                padding: '2px 0',
            }),
        }),
        [theme]
    );
};

export default useStyles;
